module.exports = __webpack_public_path__ + "img/loginLogo - 副本.e16faee0.png";